import React from 'react';
import { Check } from 'lucide-react';
import { Heading, MonoLabel, Button } from '@/components/rc';

interface ScanSuccessScreenProps {
  wineName: string;
  onScanAnother: () => void;
  onDone: () => void;
}

const ScanSuccessScreen: React.FC<ScanSuccessScreenProps> = ({ wineName, onScanAnother, onDone }) => {
  return (
    <div className="flex flex-col items-center justify-center min-h-[60vh] sm:min-h-[50vh] px-6 py-10 pb-[max(2.5rem,env(safe-area-inset-bottom))] space-y-6">
      <div className="w-16 h-16 rounded-full bg-[var(--rc-accent-acid)] flex items-center justify-center">
        <Check className="text-[var(--rc-ink-primary)]" size={32} strokeWidth={2.5} />
      </div>
      <div className="text-center space-y-2">
        <Heading scale="heading">ADDED TO CELLAR</Heading>
        <MonoLabel size="micro" colour="ghost">
          {wineName}
        </MonoLabel>
      </div>
      <div className="flex flex-col gap-3 w-full max-w-xs">
        <Button variantType="Primary" label="SCAN ANOTHER" onClick={onScanAnother} className="w-full" />
        <Button variantType="Secondary" label="DONE" onClick={onDone} className="w-full" />
      </div>
    </div>
  );
};

export default ScanSuccessScreen;
